import { useDispatch, useSelector } from 'react-redux';

import { setInfoFetch } from '../services/UserInfo/UserSlice';
import getUserInfo, {
  addUserBalance,
  getLogsByFilter,
  getRequestLogsReport,
  getUserBalanceLogs,
  getUserRequestLogs,
  getUserRequestTypes,
} from '../services/UserInfo/UserInfoActions';

const useUser = () => {
  const dispatch = useDispatch();
  const {
    info,
    isInfoFetching,
    balanceLogsHistory,
    isBalanceLogsHistoryFetching,
    requestLogs,
    isRequestLogsFetching,
  } = useSelector((state) => state.userReducer);

  const getDispatchUserInfo = (parameters = {}) =>
    dispatch(getUserInfo(parameters));
  const getDispatchBalanceHistory = (parameters = {}) =>
    dispatch(getUserBalanceLogs(parameters));
  const addDispatchUserBalance = (payload) => dispatch(addUserBalance(payload));
  const getDispatchRequestLogs = (parameters = {}) =>
    dispatch(getUserRequestLogs(parameters));
  const setFetchingUserInfo = (state) => dispatch(setInfoFetch(state));
  const getUserRequestTypesDispatch = (parameters = {}) =>
    dispatch(getUserRequestTypes(parameters));
  const getLogsReportDisptach = (parameters = {}) =>
    dispatch(getRequestLogsReport(parameters));
  const getLogsByFilterDispatcher = (parameters = {}) =>
    dispatch(getLogsByFilter(parameters));

  return {
    info,
    isInfoFetching,
    balanceLogsHistory,
    isBalanceLogsHistoryFetching,
    requestLogs,
    isRequestLogsFetching,
    getDispatchUserInfo,
    addDispatchUserBalance,
    getDispatchBalanceHistory,
    getDispatchRequestLogs,
    setFetchingUserInfo,
    getUserRequestTypesDispatch,
    getLogsReportDisptach,
    getLogsByFilterDispatcher,
  };
};

export default useUser;
